module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-wedding2-9bddc782ee45ad9b303b4dc8f70b929f.jpg";